import { createStore, applyMiddleware, compose } from 'redux';
import { createPromise } from 'redux-promise-middleware';
import { thunk as thunkMiddleware } from 'redux-thunk';
import persistState from 'redux-localstorage';
import rootReducer from './reducers';

const createStoreWithMiddleware = compose(
  // redux-localstorage 0.4.1 guards its own storage access but slices only on write.
  // Its merge must also restrict rehydration, or stale/foreign slices override reducer defaults.
  persistState('auth', {
    merge: (initialState, persistedState) =>
      persistedState && Object.prototype.hasOwnProperty.call(persistedState, 'auth') &&
      persistedState.auth !== null && typeof persistedState.auth === 'object' &&
      !Array.isArray(persistedState.auth)
        ? { ...initialState, auth: persistedState.auth }
        : initialState,
  }),
  applyMiddleware(
    thunkMiddleware,
    createPromise({
      promiseTypeSuffixes: ['LOADING', 'SUCCESS', 'ERROR']
    })
  ),
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
)(createStore);

export default function configureStore() {
  const store = createStoreWithMiddleware(rootReducer);
  return store;
}
